// Class: motion.easing._Quad.QuadEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuadEaseIn = function() {
}

// Meta

QuadEaseIn.__name__ = ["motion","easing","_Quad","QuadEaseIn"];
QuadEaseIn.__isInterface__ = false;
QuadEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
QuadEaseIn.prototype = {
	calculate: function(k) {
		return k * k;
	},
	ease: function(t,b,c,d) {
		return c * (t /= d) * t + b;
	}
};
QuadEaseIn.prototype.__class__ = QuadEaseIn.prototype.constructor = $hxClasses["motion.easing._Quad.QuadEaseIn"] = QuadEaseIn;

// Init



// Statics




// Export

exports.default = QuadEaseIn;